import { createContext, useContext } from 'react'
import type { CompanyWorkflow } from '../../domain/workflow'
import type { useWorkItemDetail } from '../../hooks/use-work-item-detail'

type WorkItemDetail = ReturnType<typeof useWorkItemDetail>

type WorkItemDetailContextValue = {
	workflow: CompanyWorkflow
	detail: WorkItemDetail
}

const WorkItemDetailContext = createContext<WorkItemDetailContextValue | null>(null)

const useWorkItemDetailContext = (): WorkItemDetailContextValue => {
	const ctx = useContext(WorkItemDetailContext)
	if (!ctx) throw new Error('useWorkItemDetailContext must be used inside WorkItemDetailContext.Provider')
	return ctx
}

export { WorkItemDetailContext, useWorkItemDetailContext }
export type { WorkItemDetail, WorkItemDetailContextValue }
